import { type PropsWithChildren, forwardRef } from "react";

import type { CarouselArrowButtonsContainerProps } from "./CarouselArrowButtonsContainer.types";
import { cn } from "$/lib/utils/functions/misc.functions";
import CarouselArrowButton from "../../atoms/CarouselArrowButton/CarouselArrowButton";
import { usePrevNextButtons } from "../../atoms/CarouselArrowButton/CarouselArrowButton.hooks";

const CarouselArrowButtonsContainer = forwardRef<
  HTMLDivElement,
  PropsWithChildren<CarouselArrowButtonsContainerProps>
>(({ emblaApi, carouselType }, forwardedRef) => {
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <div
      ref={forwardedRef}
      className={cn(
        "absolute flex w-full items-center justify-between px-3 py-0",
        {
          "top-1/2 -translate-y-1/2": carouselType !== "view-4",
          "relative justify-center gap-2 py-1": carouselType === "view-4",
        },
      )}
    >
      <CarouselArrowButton
        buttonType="prev"
        onClick={onPrevButtonClick}
        disabled={prevBtnDisabled}
        carouselType={carouselType}
      />
      <CarouselArrowButton
        buttonType="next"
        onClick={onNextButtonClick}
        disabled={nextBtnDisabled}
        carouselType={carouselType}
      />
    </div>
  );
});

CarouselArrowButtonsContainer.displayName = "CarouselArrowButtonsContainer";

export default CarouselArrowButtonsContainer;
